import { Mapper, ReadOnly } from 'module/Common';
import { Localized } from 'module/Model/Localized';

export type Category = ReadOnly<{
  id: number;
  count: number;
  name: Localized<string>;
  slug: string;
  kind: Category.CategoryKind;
}>;

export namespace Category {
  export enum CategoryKind {
    Basic = 'basic',
    Client = 'client',
  }

  const create = (input: Category) => input;

  export const mapper = Mapper.mapSchema(
    {
      id: Mapper.num,
      count: Mapper.num,
      name: Localized.mapperWithDefault('Sans Nom', 'No Name'),
      slug: Mapper.str,
      kind: Mapper.stringEnum<CategoryKind>(CategoryKind),
    },
    ({ id, count, name, slug, kind }) => create({ id, count, name, slug, kind })
  );

  export const getId = (model: Category): number => model.id;
  export const getName = (model: Category): Localized<string> => model.name;
  export const getKind = (model: Category): CategoryKind => model.kind;
  export const isClientKind = (model: Category): boolean => getKind(model) === CategoryKind.Client;
}



// WEBPACK FOOTER //
// ./src/module/Model/Categories/Category.ts